// Module
var code = "<div class=\"pull-right\"> <div class=\"plus-column approval\" style=\"float:left;text-align:center\" ng-repeat=\"n in [].constructor(vm.levelCount) track by $index\"> <wt-approval-level-name level=\"$index\"></wt-approval-level-name> </div> </div>";
// Exports
module.exports = code;